<template>
  <base-floating-card>
    <div id="event-add-contact-card">
      <div id="add-contact-art">
        <h5>Create Contact</h5>
        <add-contact-svg class="svg" />
      </div>
      <div id="search-components">
        <div id="inputs">
          <Input
            class="contact-input"
            heading="Email Address"
            :error="errors.email"
            @scs-input="emailInput"
          />
          <Input
            class="contact-input"
            heading="Phone Number"
            :error="errors.phoneNumber"
            @scs-input="phoneNumberInput"
          />
          <Input
            class="contact-input"
            heading="First Name"
            :error="errors.firstName"
            @scs-input="firstNameInput"
          />
          <Input
            class="contact-input"
            heading="Last Name"
            :error="errors.lastName"
            @scs-input="lastNameInput"
          />
          <Select
            class="contact-input"
            heading="Role"
            :options="roles"
            :formatter="
              (str) => {
                return str[0].toUpperCase() + str.substring(1);
              }
            "
            titleProperty="display"
            :initial="initialRole"
            @input="roleInput"
          />
        </div>
        <div id="buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="submitContact"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "./BaseFloatingCard.vue";
import RoundButtonWithIcon from "../RoundButtonWithIcon.vue";
import Input from "../../Elements/Input.vue";
import Select from "../../Elements/Select.vue";
import AddContactSvg from "../Illustrations/AddContact.vue";
export default {
  data() {
    return {
      processing: false,
      chosenContact: undefined,
      email: undefined,
      firstName: undefined,
      lastName: undefined,
      phoneNumber: undefined,
      errors: {
        email: false,
        firstName: false,
        lastName: false,
        phoneNumber: false,
      },
      role: "client",
      roles: ["client", "employee", "organizer", "vendor"],
    };
  },
  computed: {
    error() {
      return (
        this.errors.email ||
        this.errors.firstName ||
        this.errors.lastName ||
        this.errors.phoneNumber
      );
    },
  },
  methods: {
    async emailInput(value) {
      this.email = value;
    },
    firstNameInput(value) {
      this.firstName = value;
    },
    lastNameInput(value) {
      this.lastName = value;
    },
    phoneNumberInput(value) {
      this.phoneNumber = value;
    },
    roleInput(role) {
      this.role = role;
    },
    validate() {
      if (!this.firstName) {
        this.errors.firstName = true;
      } else {
        this.errors.firstName = false;
      }
      if (!this.lastName) {
        this.errors.lastName = true;
      } else {
        this.errors.lastName = false;
      }
      if (!this.email) {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }
      if (!this.phoneNumber) {
        this.errors.phoneNumber = true;
      } else {
        this.errors.phoneNumber = false;
      }
    },
    async submitContact() {
      this.validate();
      if (!this.error) {
        this.processing = true;
        let contact = {
          given_name: this.firstName,
          family_name: this.lastName,
          email: this.email,
          phoneNumber: this.phoneNumber,
          role: this.role,
        };
        await this.$store.dispatch("addContact", contact);
        this.processing = false;
        this.close();
      }
    },
    close() {
      this.$emit("close");
    },
  },
  components: {
    BaseFloatingCard,
    RoundButtonWithIcon,
    Input,
    Select,
    AddContactSvg,
  },
  props: ["initialRole"],
};
</script>
<style scoped>
@media screen {
  #event-add-contact-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }

  #add-contact-art {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #add-contact-art > h5 {
    margin: 0;
  }
  .svg {
    width: 100px;
  }
  #search-components {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #inputs {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .contact-input {
    width: 100%;
    margin: 5px 0;
  }

  #contact-search-results {
    padding: 20px 0;
    max-height: 200px;
    overflow: scroll;
  }

  #buttons {
    display: flex;
    width: 100px;
    padding: 10px;
    justify-content: space-between;
  }
  @media (min-width: 800px) {
    #event-add-contact-card {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
    }

    #add-contact-art {
      width: 40%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .svg {
      width: 100px;
    }
    #search-components {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    #inputs {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      flex-wrap: wrap;
    }

    .contact-input {
      width: 40%;
      margin: 5px;
    }

    #contact-search-results {
      padding: 20px 0;
      max-height: 200px;
      overflow: scroll;
    }

    #buttons {
      display: flex;
      width: 100px;
      padding: 10px;
      justify-content: space-between;
    }
  }
}
</style>
